export default $axios => ({
  // eslint-disable-next-line object-curly-newline
  submitPhone({
    phone,
    partnerUserId
  }) {
    return $axios.post(`/api/partnerUser/${partnerUserId}/update`, {
      phone
    });
  },
  submitSuggestForm({
    suggestion,
    priority,
    contactPermission,
    partnerName,
    partnerUserId,
    offerId
  }) {
    return $axios.post(`/api/partnerUser/${partnerUserId}/suggestions`, {
      suggestion,
      priority,
      contactPermission,
      partnerName,
      offerId
    });
  },
  submitHelpForm({
    question,
    itemSelected,
    partnerName,
    partnerId,
    partnerUserId,
    orderId
  }) {
    return $axios.post(`/api/partnerUser/${partnerUserId}/needHelp`, {
      question,
      itemSelected,
      partnerName,
      partnerId,
      partnerUserId,
      orderId
    });
  }
});
